module.exports = __webpack_public_path__ + "media/application/images/ui/dont-buy-5611c0c719e2af23c7faab85eeebdeb2.svg";